<div [class.hover-effect]="!matStyle && !disabled">
  <button
    #origin
    (click)="open(dropdown, origin); $event.stopPropagation()"
    (focus)="open(dropdown, origin)"
    [disabled]="disabled"
    class="mat-body-1 no-pad select-trigger"
    fxFlex="grow"
    type="button"
    >
    @if (!isOpen) {
      @if (!originTpl) {
        @if (matStyle) {
          <mat-form-field [formGroup]="selectFormGroup" appearance="outline" fxFlex="grow">
            @if (placeholder) {
              <mat-label>{{ placeholder | translate }}</mat-label>
            }
            <mat-error>{{ error | translate }}</mat-error>
            <input
              [disabled]="disabled"
              [formControlName]="selectControlName"
              [required]="require"
              [value]="label | translate"
              autocomplete="off"
              class="mat-body-1"
              matInput
              />
          </mat-form-field>
        } @else {
          @if (placeholder && !label) {
            <p class="on-surface-medium no-pad p-1">
              {{ placeholder | translate }}
            </p>
          }
          @if (label) {
            <p [class.on-surface-medium]="disabled" class="no-pad p-1">
              {{ label | translate }}
            </p>
          }
        }
      }
      <ng-template *ngTemplateOutlet="originTpl!" />
    } @else {
      @if (matStyle) {
        <mat-form-field appearance="outline" fxFlex="grow">
          @if (placeholder) {
            <mat-label>{{ placeholder | translate }}</mat-label>
          }
          <input
            (click)="$event.stopPropagation()"
            [disabled]="disabled"
            [formControl]="searchControl"
            [required]="require"
            autocomplete="off"
            autofocus
            class="mat-body-1"
            matInput
            takeFocus
            />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      } @else {
        <input
          (click)="$event.stopPropagation()"
          [disabled]="disabled"
          [formControl]="searchControl"
          [placeholder]="placeholder | translate"
          class="mat-styled-input mat-body-1"
          fxFlex="grow"
          id="search"
          takeFocus
          type="text"
          />
      }
    }
  </button>

  <ng-template #dropdown>
    <div class="select-menu mat-elevation-z3">
      @if ((loading$ | async) === false || (loading$ | async) == null) {
        <cdk-virtual-scroll-viewport
          [style.height.px]="visibleOptions * 48"
          class="select-menu-inner"
          itemSize="48"
          >
          @if (!options.length) {
            <div class="no-results-item on-surface-medium">
              {{ 'PLACEHOLDER.no_results' | translate }}
            </div>
          }
          <div
            (click)="select(option)"
            *cdkVirtualFor="let option of options; index as i"
            [class.active]="isActive(option)"
            class="select-item"
            matRipple
            >
            <span>
              @if (!optionTpl) {
                {{ displayValue(option) | translate }}
              }
              @if (!!optionTpl) {
                <ng-template *ngTemplateOutlet="optionTpl!; context: { $implicit: option, idx: i }"
                 />
              }
            </span>
          </div>
        </cdk-virtual-scroll-viewport>
      } @else {
        <div style="height: 204px; padding-top: 4px">
          @for (i of [0, 1, 2, 3]; track i) {
            <ngx-skeleton-loader [theme]="{
        width: '90%',
        height: '20px',
        margin: '12px 5%',
        padding: '0',
        backgroundColor: '#ebebeb'
      }"
               />
          }
        </div>
      }
    </div>
  </ng-template>
</div>

